import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { profile } from './profile';

const cls = ({ isActive }) => 'site-link' + (isActive ? ' active' : '');

export default function SiteNav() {
  return (
    <nav className="site-nav">
      <Link to="/" className="site-brand">{profile.name}</Link>
      <div className="site-links">
        <NavLink to="/" end className={cls}>Home</NavLink>
        <NavLink to="/publications" className={cls}>Research</NavLink>
        <NavLink to="/cv" className={cls}>CV</NavLink>
        <NavLink to="/gallery" className={cls}>Gallery</NavLink>
      </div>
    </nav>
  );
}
